export default {
  professional: {
    type: Object
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/favorite/resources/props.js